module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('approval-remarks', {
    attrs: {
      "row-data": _vm.actionData,
      "steps": _vm.actionData.steps,
      "legal-step": 3
    }
  }), _vm._v(" "), (_vm.legalApproved) ? _c('div', [(_vm.isTowerCo()) ? _c('section', [_c('el-row', [_c('el-form', {
    attrs: {
      "label-position": "top",
      "inline": _vm.isBackhaul
    }
  }, [(false) ? _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.state.contractorW),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "contractorW", $$v)
      },
      expression: "step.state.contractorW"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (false) ? _c('el-col', {
    attrs: {
      "span": 7,
      "offset": 1
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.state.contractorTI),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "contractorTI", $$v)
      },
      expression: "step.state.contractorTI"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (false) ? _c('el-col', {
    attrs: {
      "span": 7,
      "offset": 1
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.state.contractorMW),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "contractorMW", $$v)
      },
      expression: "step.state.contractorMW"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isBackhaul) ? _c('section', [_c('h4', [_vm._v("Permit to Work")]), _c('br'), _vm._v(" "), _c('check-box', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.state.approvalPTW),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "approvalPTW", $$v)
      },
      expression: "step.state.approvalPTW"
    }
  }, [_vm._v(_vm._s(_vm.step.state.approvalPTW ? 'Approved' : 'Pending / Rejected'))]), _vm._v(" "), (_vm.step.state.approvalPTW) ? _c('date-input', {
    attrs: {
      "disabled": !_vm.step.state.approvalPTW || _vm.disabled
    },
    model: {
      value: (_vm.step.state.approvedPTW),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "approvedPTW", $$v)
      },
      expression: "step.state.approvedPTW"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step.state.approvalPTW) ? _c('check-box', {
    attrs: {
      "disabled": !_vm.step.state.approvalPTW || _vm.disabled
    },
    model: {
      value: (_vm.step.state.depostiReturnedPTW),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "depostiReturnedPTW", $$v)
      },
      expression: "step.state.depostiReturnedPTW"
    }
  }, [_vm._v("Deposit Returned")]) : _vm._e()], 1) : _c('section', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('h4', [_vm._v("CME")]), _vm._v(" "), _c('check-box', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.state.approvalCME),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "approvalCME", $$v)
      },
      expression: "step.state.approvalCME"
    }
  }, [_vm._v(_vm._s(_vm.step.state.approvalCME ? 'Approved' : 'Pending / Rejected'))]), _vm._v(" "), (_vm.step.state.approvalCME) ? _c('date-input', {
    attrs: {
      "disabled": !_vm.step.state.approvalCME || _vm.disabled
    },
    model: {
      value: (_vm.step.state.approvedCME),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "approvedCME", $$v)
      },
      expression: "step.state.approvedCME"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step.state.approvalCME) ? _c('check-box', {
    attrs: {
      "disabled": !_vm.step.state.approvalCME || _vm.disabled
    },
    model: {
      value: (_vm.step.state.depostiReturnedCME),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "depostiReturnedCME", $$v)
      },
      expression: "step.state.depostiReturnedCME"
    }
  }, [_vm._v("Deposit Returned")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('h4', [_vm._v("TI")]), _vm._v(" "), _c('check-box', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.state.approvalTI),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "approvalTI", $$v)
      },
      expression: "step.state.approvalTI"
    }
  }, [_vm._v(_vm._s(_vm.step.state.approvalTI ? 'Approved' : 'Pending / Rejected'))]), _vm._v(" "), (_vm.step.state.approvalTI) ? _c('date-input', {
    attrs: {
      "format": _vm.dateFormat,
      "disabled": !_vm.step.state.approvalTI || _vm.disabled
    },
    model: {
      value: (_vm.step.state.approvedTI),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "approvedTI", $$v)
      },
      expression: "step.state.approvedTI"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step.state.approvalTI) ? _c('check-box', {
    attrs: {
      "disabled": !_vm.step.state.approvalTI || _vm.disabled
    },
    model: {
      value: (_vm.step.state.depostiReturnedTI),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "depostiReturnedTI", $$v)
      },
      expression: "step.state.depostiReturnedTI"
    }
  }, [_vm._v("Deposit Returned")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('h4', [_vm._v("MW")]), _vm._v(" "), _c('check-box', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.state.approvalMW),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "approvalMW", $$v)
      },
      expression: "step.state.approvalMW"
    }
  }, [_vm._v(_vm._s(_vm.step.state.approvalMW ? 'Approved' : 'Pending / Rejected'))]), _vm._v(" "), (_vm.step.state.approvalMW) ? _c('date-input', {
    attrs: {
      "disabled": !_vm.step.state.approvalMW || _vm.disabled
    },
    model: {
      value: (_vm.step.state.approvedMW),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "approvedMW", $$v)
      },
      expression: "step.state.approvedMW"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step.state.approvalMW) ? _c('check-box', {
    attrs: {
      "disabled": !_vm.step.state.approvalMW || _vm.disabled
    },
    model: {
      value: (_vm.step.state.depostiReturnedMW),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "depostiReturnedMW", $$v)
      },
      expression: "step.state.depostiReturnedMW"
    }
  }, [_vm._v("Deposit Returned")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    class: _vm.disabled ? '' : 'bg-lighter',
    style: (_vm.disabled ? '' : 'padding-left: 1em; padding-top: 1em; border-radius: 1em;'),
    attrs: {
      "span": 22
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('check-box', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.state.depositRequired),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "depositRequired", $$v)
      },
      expression: "step.state.depositRequired"
    }
  }, [_vm._v("Overall Deposit Required")]), _vm._v(" "), (_vm.step.state.depositRequired) ? _c('el-form-item', {
    attrs: {
      "label": "Paid"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.state.paid),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "paid", $$v)
      },
      expression: "step.state.paid"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.step.state.depositRequired) ? _c('el-form-item', {
    attrs: {
      "label": "Amount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "disabled": !_vm.step.state.paid || _vm.disabled
    },
    model: {
      value: (_vm.step.state.deposit),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "deposit", $$v)
      },
      expression: "step.state.deposit"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.currencyLabel))])], 2)], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (this.isActive(this.actionData)) ? _c('el-alert', {
    attrs: {
      "type": "info",
      "title": "Progress Remarks",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('html-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.remarks),
      callback: function($$v) {
        _vm.$set(_vm.step, "remarks", $$v)
      },
      expression: "step.remarks"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c7dafe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/workflow/step4.vue
// module id = 1426
// module chunks = 0